module.exports = __webpack_public_path__ + "static/media/Step5.d56a2f66.png";